import { useEffect, useState } from 'react';

import introImg from '../../../../assets/images/courses/team-players/chapter3.1.jpg';
import chapterImg2 from '../../../../assets/images/courses/team-players/chapter3.2.jpg';
import chapterImg3 from '../../../../assets/images/courses/team-players/chapter3.3.1.jpg';
import chapterImg4 from '../../../../assets/images/courses/team-players/chapter3.3.2.jpg';
import chapterImg5 from '../../../../assets/images/courses/team-players/chapter3.3.3.jpg';
import chapterImg6 from '../../../../assets/images/courses/team-players/chapter3.3.4.jpg';
import chapterImg7 from '../../../../assets/images/courses/team-players/chapter3.3.5.jpg';
import chapterImg8 from '../../../../assets/images/courses/team-players/chapter3.3.6.jpg';
import chapterImg13 from '../../../../assets/images/courses/team-players/chapter3.4.1.jpg';
import chapterImg9 from '../../../../assets/images/courses/team-players/chapter3.4.2.jpg';
import chapterImg10 from '../../../../assets/images/courses/team-players/chapter3.4.3.jpg';
import chapterImg11 from '../../../../assets/images/courses/team-players/chapter3.4.4.jpg';
import chapterImg12 from '../../../../assets/images/courses/team-players/chapter3.4.5.jpg';
import chapterImg14 from '../../../../assets/images/courses/team-players/chapter3.5.1.jpg';
import chapterImg15 from '../../../../assets/images/courses/team-players/chapter3.5.2.jpg';
import chapterImg16 from '../../../../assets/images/courses/team-players/chapter3.5.3.jpg';
import chapterImg17 from '../../../../assets/images/courses/team-players/chapter3.6.1.jpg';
import chapterImg18 from '../../../../assets/images/courses/team-players/chapter3.6.2.jpg';
import chapterImg19 from '../../../../assets/images/courses/team-players/chapter3.6.3.jpg';
import { CourseChapter } from '../../../../courses/courses.types';
import {
  CourseQuestionAnswer,
  QuestionOption,
} from '../../../../courses/jumpstart-communicator/jumpstart-communicator.types';
import { course_questions as courseQuestions } from '../../../../courses/team-players/team-players-quiz';
import { useUserCourseQuestionResponseContext } from '../../../../hooks/use-user-course-question-response.hooks';
import {
  dispatchUpdateUserCourseQuestionResponse,
  UserChapterQuestion,
} from '../../../../redux/slice/user-course-question-response';
import { useAppDispatch } from '../../../../redux/store';
import { CustomAccordion } from '../../../common/Accordion';
import { CarouselComponent } from '../../CarouselComponent';
import { CourseQuestionCard } from '../../CourseQuestionCard';
import { MediaBlock } from '../../MediaBlock';

type AnswersState = {
  [question: string]: CourseQuestionAnswer;
};
interface TeamPlayersProps {
  chapter: CourseChapter;
  onNextChapter: (nextIndex: number) => void;
  totalPages: number;
  courseId?: string;
  onQuizResult?: (result: boolean | undefined) => void;
}

export const TeamPlayersChapter3: React.FC<TeamPlayersProps> = ({
  chapter,
  onNextChapter,
  totalPages,
}) => {
  const dispatch = useAppDispatch();
  const [isPageDirty, setIsPageDirty] = useState(true);

  const userCourseQuestionResponseContext = useUserCourseQuestionResponseContext();
  const [, setAnswers] = useState<AnswersState>({});
  const chapterQuestions = courseQuestions.filter(
    (courseChapter) => courseChapter.chapter_id === chapter.id,
  );
  const handleCourseAnswerSubmit = async (
    quizAnswers: QuestionOption[],
    isCorrect: boolean,
    questionId?: string,
  ) => {
    setAnswers((prevAnswers) => {
      if (questionId) {
        return {
          ...prevAnswers,
          [questionId]: {
            chapter_id: chapter.id,
            question_id: questionId,
            question: chapterQuestions[0].question,
            is_correct: isCorrect,
            answer_options: quizAnswers,
          },
        };
      } else {
        return { ...prevAnswers };
      }
    });

    const userQuestionAnswer: UserChapterQuestion = {
      question_id: questionId,
      isCorrect: isCorrect,
      question: chapterQuestions.find((x) => x.id === questionId)?.question,
      answers: quizAnswers,
    };
    const userAnswerResponse =
      userCourseQuestionResponseContext[chapterQuestions[0].course_id]?.chapters[chapter.id]
        ?.questions || [];

    await dispatch(
      dispatchUpdateUserCourseQuestionResponse({
        [chapterQuestions[0].course_id]: {
          chapters: {
            [chapter.id]: {
              questions: [
                ...userAnswerResponse.filter((x) => x.question_id !== questionId),
                userQuestionAnswer,
              ],
              quiz: null,
            },
          },
        },
      }),
    );
  };
  const handleQuestionRetake = async (questionId: string) => {
    setAnswers((prevAnswers) => {
      //eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [questionId]: _, ...newState } = prevAnswers;
      return newState;
    });
    const userAnswerResponse =
      userCourseQuestionResponseContext[chapterQuestions[0].course_id]?.chapters[chapter.id]
        ?.questions || [];

    await dispatch(
      dispatchUpdateUserCourseQuestionResponse({
        [chapterQuestions[0].course_id]: {
          chapters: {
            [chapter.id]: {
              questions: [...userAnswerResponse.filter((x) => x.question_id !== questionId)],
              quiz: null,
            },
          },
        },
      }),
    );
    setIsPageDirty(true);
  };

  const handleNextChapterClick = () => {
    onNextChapter(chapter.index + 1);
  };

  const handlePrint = (view: string) => {
    const printArea = document.getElementById(view);
    if (printArea) {
      printArea.classList.add('print-view');

      const cleanup = () => {
        printArea.classList.remove('print-view');
        window.onafterprint = null;
      };

      window.onafterprint = cleanup;

      window.print();
    }
  };

  const slidesData = [
    {
      heading: 'Phases Include ...',
      paragraph: `<p>In any project, there are five main phases:</p>`,
      list: [],
      image: chapterImg3,
    },
    {
      heading: 'Direction-setting Phase',
      paragraph: `<p>Here, the focus is on suggesting big, long-term goals, establishing processes, and assigning roles. This phase involves planning and setting up the framework for the project.</p>`,
      list: [],
      image: chapterImg4,
    },
    {
      heading: 'Planning Phase',
      paragraph: `<p>This stage involves generating ideas, evaluating their quality, and consolidating them into a cohesive plan. Consider how you can contribute—are you better at generating ideas or evaluating their feasibility?</p>`,
      list: [],
      image: chapterImg5,
    },
    {
      heading: 'Briefing Others Phase',
      paragraph: `<p>Not everyone may have been involved in the planning, so it's essential to ensure everyone on the team understands the plan. This phase may involve presentations, one-on-one explanations, delegating tasks, and confirming understanding.</p>`,
      list: [],
      image: chapterImg6,
    },
    {
      heading: 'Action Phase',
      paragraph: `<p>This is when the plan is put into motion, with team members executing their agreed-upon tasks. This phase may include problem-solving, maintaining quality, attention to detail, and perseverance through challenges. Additionally, someone in the team may need to attend to people functions, such as helping others, mediating disputes, and providing humor to maintain morale.</p>`,
      list: [],
      image: chapterImg7,
    },
    {
      heading: 'Finishing Phase',
      paragraph: `<p>Finally, the project is wrapped up, with attention to completing all remaining details and ensuring thoroughness. This may involve conducting a review to learn from the project's outcomes and document lessons for future endeavors.</p>`,
      list: [],
      image: chapterImg8,
    },
  ];

  const accordionData1 = [
    {
      id: 'panel1',
      title: 'Phase 1: Direction-setting Phase - Setting the Goals and Framework',
      image: chapterImg13,
      content: `<p>The student council decides to organize a school talent show to showcase students' diverse talents and raise funds for a local charity. During the first meeting, Alex, who excels at setting big-picture goals, suggests the main objectives: providing a platform for students to perform, creating a fun school event, and raising $1,000 for charity. Taylor, known for their organizational skills, outlines the initial processes, such as securing a venue, setting a date, and recruiting participants. Roles are assigned: Jamie will handle sponsorships, Sam will manage participant relations, and Morgan will oversee marketing. </p>`,
    },
    {
      id: 'panel2',
      title: 'Phase 2: Planning Phase - Generating Ideas and Creating a Plan',
      image: chapterImg9,
      content: `<p>The team gathers for a brainstorming session. Chris, bursting with creativity, suggests various performance categories like singing, dancing, and comedy acts, as well as engaging intermission activities. Avery, the critical thinker, evaluates these ideas for feasibility and potential challenges. After thorough discussion, the team consolidates the ideas into a cohesive plan: a themed talent show with prizes for winners, several intermission games, and a food stall. They finalize the budget, create a timeline, and set key milestones.</p>`,
    },
    {
      id: 'panel3',
      title: 'Phase 3: Briefing Others Phase - Ensuring Everyone Understands the Plan',
      image: chapterImg10,
      content: `<p>Not all student council members were involved in the initial planning, so Alex organizes a presentation to brief everyone on the finalized plan. Jamie and Morgan give one-on-one explanations to volunteers who will help on the day of the event, ensuring everyone knows their tasks and responsibilities. Taylor delegates specific tasks, such as setting up the stage and managing ticket sales, confirming that all team members understand their roles and the event’s objectives. </p>`,
    },
    {
      id: 'panel4',
      title: 'Phase 4: Action Phase - Executing the Plan',
      image: chapterImg11,
      content: `<p>The day of the talent show arrives, and the plan is put into motion. Taylor keeps everything running smoothly, solving problems as they arise, such as a last-minute sound system issue. Chris ensures the stage decorations are perfect, while Sam keeps the participants calm and ready to perform. Jamie supervises the sponsorship booths, making sure they are set up and running. Jordan, the inspirer, brings energy and humor, keeping morale high despite the hectic environment. Avery monitors the event’s quality, ensuring everything goes as planned.</p>`,
    },
    {
      id: 'panel5',
      title: 'Phase 5: Finishing Phase - Wrapping Up and Reviewing',
      image: chapterImg12,
      content: `<p>The talent show ends successfully, with students and attendees having enjoyed the performances. Alex leads the team in wrapping up, making sure all equipment is returned and the venue is cleaned. The team conducts a review session the following week to discuss what went well and what could be improved. They document lessons learned, such as the importance of having a backup sound system, and celebrate their achievement of raising over $1,200 for charity.</p>`,
    },
  ];
  useEffect(() => {
    const userAnswerResponse =
      userCourseQuestionResponseContext[chapterQuestions[0].course_id]?.chapters[chapter.id]
        ?.questions;

    if (Object.keys(userCourseQuestionResponseContext).length && userAnswerResponse?.length) {
      setIsPageDirty(false);
    }
  }, [userCourseQuestionResponseContext]);

  return (
    <>
      <div className="content-wrap lg:border-l lg:pl-8 lg:pt-8 pt-4 pb-10">
        <p className="text-sm italic  mb-7">
          Part {chapter.index} of {totalPages}
        </p>
        <h2 className="font-semibold text-3xl">Overview</h2>

        <MediaBlock mediaImage={introImg}></MediaBlock>
        <br />

        <p className="text-2xl text-center mt-7 mb-20 leading-10">
          Understanding when you shine during a team project is crucial. Your abilities or skills
          may be more suited to certain project phases. For instance, creative individuals thrive at
          the project's start, but too many ideas near the end can be overwhelming.
        </p>
        <div className="md:flex items-center mt-10 mb-10">
          <div className="md:mr-8 max-w-full md:max-w-xs w-full mb-5 md:mb-0">
            <img src={chapterImg2} alt="" />
          </div>
          <p className="flex-1 leading-6">
            <br />
            Ideally, they should shift their focus to implementation or quality control once the
            plan is set. Recognizing your strengths at each project phase helps ensure you
            contribute effectively throughout.
          </p>
        </div>
        <p className="text-lg text-center mt-7 mb-20 leading-10">
          When we show up to the present moment with all of our senses, we invite the world to fill
          us with joy. The pains of the past are behind us. The future has yet to unfold. But the
          now is full of beauty simply waiting for our attention.
        </p>
        <div className="border rounded-3xl mr-8">
          <CarouselComponent data={slidesData} isRequired={false} />
        </div>
        <br />

        <h2 className="font-semibold text-3xl">
          Example Scenario: Organizing a School Talent Show{' '}
        </h2>
        <p className="text-lg  font-light mt-8 mb-8">
          Let's apply the 5 phases based on a similar scenario we looked at in the previous section.{' '}
          <br /> Click on each '+' icon to learn more.
        </p>

        {accordionData1.map((data) => (
          <CustomAccordion
            key={data.title}
            title={data.title}
            content={data.content}
            id={data.id}
            image={data?.image}
          />
        ))}

        <br />
        <h2 className="font-semibold text-3xl">Key Takeaways:</h2>
        <ul className="list-disc pl-5 mt-8 mb-14 text-xl font-light">
          <li className="pl-9 mb-7">
            Direction-setting: Establish big goals and processes, assign roles.
          </li>
          <li className="pl-9 mb-7">
            Planning: Generate and evaluate ideas, consolidate into a plan.
          </li>
          <li className="pl-9 mb-7">
            Briefing Others: Ensure everyone understands the plan and their roles.
          </li>
          <li className="pl-9 mb-7">
            Action: Execute the plan, solve problems, maintain quality and morale.
          </li>
          <li className="pl-9 mb-7">
            Finishing: Wrap up the project, review and document lessons learned.
          </li>
        </ul>

        <p className="text-lg  font-light mt-8 mb-8">
          This scenario illustrates how each phase of a project involves different roles and
          responsibilities, highlighting the importance of collaboration and effective communication
          in achieving a common goal.
        </p>

        <h3 className="text-2xl text-purple-600 font-bold m-5">Reflect</h3>
        <p className="text-xl font-light flex-1 mt-5 mb-5">
          Complete the following questions, you may print your responses upon completion.
        </p>

        <div id="print-view1" className="mt-5 mb-5">
          <ol className="list-decimal pl-7 mb-14 text-xl font-light">
            <li className="mb-5">
              {' '}
              <div>
                <p className="m-4">
                  Think about how you can be a great contributor throughout every team project that
                  you are involved in. Which of the stages are you less naturally good at?
                </p>
                <textarea
                  className="w-full h-32 p-2 border rounded"
                  placeholder="Enter your text here..."
                ></textarea>
              </div>
            </li>

            <li className="mb-5">
              {' '}
              <div>
                <p className="m-4">
                  For the phases you identified above, how could you work out a role for yourself
                  and therefore enable yourself to contribute better during that phase?
                </p>
                <textarea
                  className="w-full h-32 p-2 border rounded"
                  placeholder="Enter your text here..."
                ></textarea>
              </div>
            </li>
          </ol>

          <div className="mt-5 text-right">
            <button onClick={() => handlePrint('print-view1')} className="btn-internal">
              PRINT
            </button>
          </div>
        </div>
        <br />
        <h3 className="text-3xl text-purple-600 font-bold m-5">Levels of Collaboration</h3>
        <p className="text-xl font-light flex-1 mt-5 mb-5">
          Different occupations demand varying levels of skill in collaboration based on the nature
          of the work and the team dynamics involved.
        </p>

        <div className="md:flex items-center mt-7 mb-7">
          <div className="md:mr-8 max-w-full md:max-w-xs w-full mb-5 md:mb-0">
            <img src={chapterImg14} alt="" />
          </div>
          <p className="flex-1 leading-7">
            <strong className="mb-4"> Software Developers</strong>
            <br />
            <br />
            For instance, software developers often work in teams where collaboration is essential,
            but the focus is on integrating individual contributions into a cohesive final product.
            They need to communicate effectively with team members, share progress, and solve
            problems together, but a significant portion of their work is done independently.
          </p>
        </div>
        <div className="md:flex items-center mb-7">
          <p className="flex-1 leading-7">
            <strong className="mb-4"> Healthcare Professional</strong>
            <br />
            <br />
            On the other hand, healthcare professionals, such as nurses, require a high level of
            collaborative skill daily. They must constantly coordinate with doctors, other nurses,
            and support staff to ensure patient care is seamless and effective, often under
            high-pressure situations where teamwork is critical to patient outcomes.
          </p>
          <div className="md:mr-8 max-w-full md:max-w-xs w-full mb-5 md:mb-0">
            <img src={chapterImg15} alt="" />
          </div>
        </div>
        <div className="md:flex items-center mb-7">
          <div className="md:mr-8 max-w-full md:max-w-xs w-full mb-5 md:mb-0">
            <img src={chapterImg16} alt="" />
          </div>
          <p className="flex-1 leading-7">
            <strong className="mb-4">Freelance Graphic Designers</strong>
            <br />
            <br />
            In contrast, freelance graphic designers may collaborate less frequently, as much of
            their work is done solo. However, when they do collaborate—such as when working with
            clients or other creative professionals—strong collaboration skills are necessary to
            understand and meet the client’s needs, integrate feedback, and align their work with
            the broader project vision.
          </p>
        </div>
        <br />

        <p className="text-xl font-bold text-left mt-7 mb-20 leading-10">
          Each of these occupations demonstrates how collaboration demands can vary significantly
          depending on the role and industry.
        </p>

        <h3 className="text-2xl text-purple-600 font-bold m-5">
          Activity: Levels of Collaboration
        </h3>
        <p className="text-xl font-light flex-1 mt-5 mb-5 leading-7">
          The following examples illustrate how three different occupations demand different levels
          of skill in collaboration. Read the examples and answer the question for each.
        </p>
        <br />
        {/* Horizontal Line   ..................................................................................*/}
        <div className="relative flex items-center justify-center w-full mb-8 mt-8">
          <div className="w-full border-t border-gray-300"></div>
          <div
            className="absolute bg-purple-500 text-white font-bold flex items-center justify-center 
      w-10 h-10 rounded-full text-lg shadow-lg"
          >
            1
          </div>
        </div>
        <div className="md:flex items-center mb-7">
          <p className="flex-1 leading-7">
            <br /> 1. <strong>Machinists</strong> work independently to interpret, plan and produce
            or repair parts. They work with other machinists to carry out new or complex tasks or to
            solve problems. In larger organizations, they work with engineering staff to ensure
            documentation is complete and accurate, and with other trades people, such as
            electricians or welders, to repair or maintain equipment. They participate in leadership
            activities such as making suggestions on improving work processes and orienting new
            employees.
          </p>
          <div className="md:mr-8 max-w-full md:max-w-xs w-full mb-5 md:mb-0">
            <img src={chapterImg17} alt="" />
          </div>
        </div>
        <CourseQuestionCard
          submittedAnswer={userCourseQuestionResponseContext[
            chapterQuestions[0].course_id
          ]?.chapters[chapter.id]?.questions?.find((x) => x.question_id === chapterQuestions[0].id)}
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          onSubmitAnswer={handleCourseAnswerSubmit}
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          onRetakeQuestion={handleQuestionRetake}
          question={chapterQuestions[0]}
        />
        <br />
        <div className="relative flex items-center justify-center w-full mb-8 mt-8">
          <div className="w-full border-t border-gray-300"></div>
          <div
            className="absolute bg-purple-500 text-white font-bold flex items-center justify-center 
      w-10 h-10 rounded-full text-lg shadow-lg"
          >
            2
          </div>
        </div>
        <div className="md:flex items-center mb-7">
          <p className="flex-1 leading-7">
            <br />
            2. <strong>Trappers and hunters</strong> mostly work alone. Some work with a partner.
            Because of the danger of travelling in dense woodlands, many hunters and trappers share
            their work schedule with hunters and trappers in adjoining areas so that assistance is
            available if they do not reappear at the appointed times. They participate in leadership
            activities such as mentoring new trappers and passing on traditional ways of working.
          </p>
          <div className="md:mr-8 max-w-full md:max-w-xs w-full mb-5 md:mb-0">
            <img src={chapterImg18} alt="" />
          </div>
        </div>
        <CourseQuestionCard
          submittedAnswer={userCourseQuestionResponseContext[
            chapterQuestions[0].course_id
          ]?.chapters[chapter.id]?.questions?.find((x) => x.question_id === chapterQuestions[1].id)}
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          onSubmitAnswer={handleCourseAnswerSubmit}
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          onRetakeQuestion={handleQuestionRetake}
          question={chapterQuestions[1]}
        />

        <br />
        <br />
        <div className="relative flex items-center justify-center w-full mb-8 mt-8">
          <div className="w-full border-t border-gray-300"></div>
          <div
            className="absolute bg-purple-500 text-white font-bold flex items-center justify-center 
      w-10 h-10 rounded-full text-lg shadow-lg"
          >
            3
          </div>
        </div>
        <div className="md:flex items-center mb-7">
          <p className="flex-1 leading-7">
            <br />
            3. <strong>Bakers</strong> work independently to prepare, bake, assemble and decorate
            baked goods. They coordinate and integrate tasks with other bakers in order to share
            resources such as ovens and workspaces. They participate in leadership activities such
            as formal discussions about work processes and demonstrating to other workers how tasks
            are performed.
          </p>
          <div className="md:mr-8 max-w-full md:max-w-xs w-full mb-5 md:mb-0">
            <img src={chapterImg19} alt="" />
          </div>
        </div>
        <CourseQuestionCard
          submittedAnswer={userCourseQuestionResponseContext[
            chapterQuestions[0].course_id
          ]?.chapters[chapter.id]?.questions?.find((x) => x.question_id === chapterQuestions[2].id)}
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          onSubmitAnswer={handleCourseAnswerSubmit}
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          onRetakeQuestion={handleQuestionRetake}
          question={chapterQuestions[2]}
        />
        <p className="text-lg font-normal text-left mt-7 mb-20 leading-10">
          <strong>Part 2 :</strong> Select at least one of the occupations listed in the chart below
          and conduct your own online research into how workers in that job collaborate. Provide at
          least one example of how they work alone or independently and with a partner or a team.
          You may print your response upon completion.
        </p>
        <p className="text-lg font-bold text-left mt-7 mb-20 leading-10">
          Click on the marker 'X' for some possible hints for the occupations listed.
        </p>
        <div id="print-view2" className="overflow-x-auto">
          <table className="seek-information w-full">
            <thead>
              <tr>
                <th style={{ backgroundColor: 'blueviolet', color: 'whitesmoke' }}>Occupation</th>
                <th style={{ backgroundColor: 'blueviolet', color: 'whitesmoke' }}>
                  Alone/Independently
                </th>
                <th style={{ backgroundColor: 'blueviolet', color: 'whitesmoke' }}>
                  With a partner/on a team
                </th>
              </tr>
            </thead>
            <tbody className="bg-purple-100">
              <tr>
                <td>
                  <div className=" text-lg font-bold ">Aircraft Mechanic</div>
                </td>
                <td>
                  <textarea
                    className="w-full h-32 p-2 border rounded"
                    placeholder="Enter your text here..."
                  ></textarea>
                </td>
                <td>
                  <textarea
                    className="w-full h-32 p-2 border rounded"
                    placeholder="Enter your text here..."
                  ></textarea>
                </td>
              </tr>
              <tr>
                <td>
                  <div className=" text-lg font-bold ">Landscaper</div>
                </td>
                <td>
                  <textarea
                    className="w-full h-32 p-2 border rounded"
                    placeholder="Enter your text here..."
                  ></textarea>
                </td>
                <td>
                  <textarea
                    className="w-full h-32 p-2 border rounded"
                    placeholder="Enter your text here..."
                  ></textarea>
                </td>
              </tr>
              <tr>
                <td>
                  <div className=" text-lg font-bold ">Mining Mechanic</div>
                </td>
                <td>
                  <textarea
                    className="w-full h-32 p-2 border rounded"
                    placeholder="Enter your text here..."
                  ></textarea>
                </td>
                <td>
                  <textarea
                    className="w-full h-32 p-2 border rounded"
                    placeholder="Enter your text here..."
                  ></textarea>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="mt-5 mb-5 text-right">
            <button onClick={() => handlePrint('print-view2')} className="btn-internal">
              PRINT
            </button>
          </div>
        </div>
        <br />
        <h3 className="text-2xl  text-center font-light mt-10 mb-5 ">
          There is more to being part of a team than just showing up; we also need to contribute in
          ways that help the team achieve its goals. Effective team members who make useful
          contributions display some common behaviors. Next we will review some of these behaviors.
        </h3>
        <br />
        <button
          disabled={isPageDirty}
          onClick={handleNextChapterClick}
          className="btn-internal w-full"
        >
          Characteristics of a Great Team
        </button>
      </div>
    </>
  );
};
